import React from 'react';
import { LoadingSpinner } from '@kcd/design-system';

export const LoadingSpinnerCenter = (
  props: React.ComponentProps<typeof LoadingSpinner>,
) => {
  return (
    <LoadingSpinner
      size={32}
      verticalCenter
      className="[&>[aria-label='loading']]:-translate-y-full"
      {...props}
    />
  );
};
